import { MODAL_TYPE, useActiveProject, useModal } from '@nx/state';
import { useEffect } from 'react';
import { Navigate } from 'react-router';

export const InviteDeeplinkRedirect = () => {
  const inviteModal = useModal(MODAL_TYPE.PROJECT_INVITE);

  const activeProject = useActiveProject(false);

  useEffect(() => {
    if (activeProject && !inviteModal.isOpen) {
      inviteModal.open({ project: activeProject });
    }
  }, [activeProject, inviteModal]);

  return <Navigate to="/" />;
};
